// extracted by mini-css-extract-plugin
export default {"modalContent":"itzH0nW3E2mwZviuBalk","borderBottom":"s0PSDI597KsfvhnN_X64","borderTop":"rssDG_R4H4_jvHR7_lBI","placeHolderShimmer":"tWEeU86z92hU4n9BZ1LA"};